// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"58d779f4","977":"a341b77e"}[chunkId] + ".chunk.js";
};